import type { PropsWithChildren } from 'react';

export type ActionsBarProps = PropsWithChildren;

export const ActionsBar = ({ children }: ActionsBarProps) => (
  <div className="bg-color-background-base sticky bottom-0 z-10 overflow-hidden shadow-sm [clip-path:inset(-10px_0_0_0)]">
    {children}
  </div>
);
